import Router from "./router";
import { RowsTableProvider } from "./helpers/resolutionsContext/resolutionCtx";

function App() {
  return(
    <RowsTableProvider initialRows={[]}>
      <Router />;
    </RowsTableProvider>
  ) 
}

export default App;
